<template>
  <div id="wrap">
    <app-header />
    <header-step step="2" alt="ステップ２：お申込み内容入力" />

    <main>
      <h2><span>お申込み内容をご入力ください</span></h2>
      <form name="app" id="f-inp" ref="fInp">
        <div class="section">
          <!-- 保護者・代表者の情報 -->
          <div>
            <h3>保護者・代表者の情報</h3>
            <ul>
              <li>
                <p class="v_t">
                  保護者・代表者の氏名<span class="req">必須</span>
                </p>
                <div class="v_t">
                  <input
                    type="text"
                    name="family-name"
                    placeholder="姓"
                    autocomplete="on"
                    v-model="parentSei"
                  />
                </div>
                <div class="v_t">
                  <input
                    type="text"
                    name="given-name"
                    placeholder="名"
                    autocomplete="on"
                    v-model="parentMei"
                  />
                </div>
              </li>
              <li>
                <p class="v_t">
                  保護者・代表者のふりがな<span class="req">必須</span>
                </p>
                <div class="v_t">
                  <input
                    type="text"
                    name="family-name_kana"
                    placeholder="せい"
                    autocomplete="on"
                    v-model="parentSeiKana"
                  />
                </div>
                <div class="v_t">
                  <input
                    type="text"
                    name="given-name_kana"
                    placeholder="めい"
                    autocomplete="on"
                    v-model="parentMeiKana"
                  />
                </div>
              </li>
            </ul>
          </div>
          <!-- お子様の情報 -->
          <div>
            <h3>お子様の情報</h3>
            <ul>
              <li>
                <p class="v_t">お子様の氏名<span class="req">必須</span></p>
                <div class="v_t">
                  <input
                    type="text"
                    name="child_family-name"
                    placeholder="姓"
                    v-model="studentSei"
                  />
                </div>
                <div class="v_t">
                  <input
                    type="text"
                    name="child_given-name"
                    placeholder="名"
                    v-model="studentMei"
                  />
                </div>
              </li>
              <li>
                <p class="v_t">お子様のふりがな<span class="req">必須</span></p>
                <div class="v_t">
                  <input
                    type="text"
                    name="child_family-name_kana"
                    placeholder="せい"
                    v-model="studentSeiKana"
                  />
                </div>
                <div class="v_t">
                  <input
                    type="text"
                    name="child_given-name_kana"
                    placeholder="めい"
                    v-model="studentMeiKana"
                  />
                </div>
              </li>
              <li>
                <p>学校名</p>
                <div>
                  <input
                    type="text"
                    name="school-name"
                    disabled="disabled"
                    v-model="schoolNm"
                  />
                </div>
              </li>
              <li>
                <p>学年<span class="req">必須</span></p>
                <div>
                  <select name="grade" v-model="gradeId">
                    <option value="">選択してください</option>
                    <option
                      v-for="one in gradeList"
                      :key="one.grade_id"
                      :value="one.grade_id"
                    >
                      {{ one.grade_sname }}
                    </option>
                  </select>
                  <p class="att red bold">※お申込み時点での学年を選択してください。</p>
                  <p class="att">〇入学前の申し込みの場合（3/31までの申し込み）</p>
							<p class="att2">
							  ●小学校（１～６年）の場合&#x3000;&#x3000;<br />
									&#x3000;新１年生の場合、「新入生」でお申し込みください。<br />
									&#x3000;その他の学年の場合<br />
									&#x3000;例】新２年生の場合「１年」でお申し込みください。<br />
									&#x3000;&#x3000;&#x3000;新６年生の場合「５年」でお申し込みください。
							</p>
							<p class="att2">
							  ●小中一貫校、小中高一貫校の場合&#x3000;&#x3000;<br />
									&#x3000;例】<br />
									&#x3000;【小】新１年生の場合、「新入生」でお申し込みください。<br />
									&#x3000;【中】新１年生の場合、「６年」でお申し込みください。<br />
									&#x3000;【高】新１年生の場合、「中３」でお申し込みください。<br />
							</p>
							<p class="att2">
							  ●中高一貫校の場合&#x3000;&#x3000;<br />
									&#x3000;例】<br />
									&#x3000;【中】新１年生の場合、「新入生」でお申し込みください。<br />
									&#x3000;【高】新１年生の場合、「中３」でお申し込みください。<br />
							</p>
                </div>
              </li>
              <li>
                <p>クラス<span class="req">必須</span></p>
                <div>
                  <select name="class" v-model="classId">
                    <option value="">選択してください</option>
                    <option
                      v-for="one in classList"
                      :key="one.class_id"
                      :value="one.class_id"
                    >
                      {{ one.class_sname }}
                    </option>
                  </select>
                  <p class="att red bold">※お申し込み時点でクラスがわかない場合、<br />「未登録」を選択してください。</p>                 
                </div>
              </li>
            </ul>
          </div>
          <!-- ご連絡先情報 -->
          <div>
            <h3>ご連絡先情報</h3>
            <ul>
              <li>
                <p>郵便番号（ハイフン無し）<span class="req">必須</span></p>
                <div>
                  <input
                    type="number"
                    name="postal-code"
                    id="postal-code"
                    maxlength="7"
                    autocomplete="on"
                    v-model="zip"
                    @input="onChangeZip"
                  />
                  <button
                    type="button"
                    class="zip_btn"
                    id="zip_btn"
                    @click="onClickZipBtn"
                  >
                    <fa-icon :icon="['fas', 'mail-bulk']"></fa-icon
                    >郵便番号を調べる
                  </button>
                  <span id="postal-code_error"></span>
                </div>
              </li>
              <li>
                <p>都道府県<span class="req">必須</span></p>
                <div>
                  <input
                    type="text"
                    name="address-level1"
                    placeholder="都道府県"
                    readonly="readonly"
                    autocomplete="on"
                    v-model="prefNm"
                    ref="pref"
                  />
                </div>
              </li>
              <li>
                <p>市区町村<span class="req">必須</span></p>
                <div>
                  <input
                    type="text"
                    name="address-level2"
                    placeholder="市区町村"
                    readonly="readonly"
                    autocomplete="on"
                    v-model="addr1"
                    ref="addr1"
                  />
                </div>
              </li>
              <li>
                <p>丁目・番地・マンション名等<span class="req">必須</span></p>
                <div>
                  <input
                    type="text"
                    name="address-level3"
                    placeholder="例）4丁目4-7 8F"
                    autocomplete="on"
                    v-model="addr2"
                    ref="addr2"
                  />
                </div>
              </li>
              <li>
                <p>
                  緊急連絡先<span class="req">必須</span
                  ><br />（携帯電話番号・ハイフン無し）
                </p>
                <div>
                  <input
                    id="mobile-tel"
                    type="tel"
                    name="tel"
                    placeholder="00000000000"
                    autocomplete="on"
                    ref="mobileTel"
                    v-model="telM"
                    v-cleave="{
                      phone: true,
                      phoneRegionCode: 'JP',
                      delimiter: ' ',
                      onValueChanged: telChanged,
                    }"
                  />
                  <p class="att">
                    ※緊急連絡先（携帯電話番号）は必ずご入力ください。
                  </p>
                </div>
              </li>
              <li>
                <p>
                  固定電話番号<br class="pc" />（市外局番から・ハイフン無し）
                </p>
                <div>
                  <input
                    id="fixed-tel"
                    type="tel"
                    name="tel2"
                    placeholder="0000000000"
                    autocomplete="on"
                    ref="fixedTel"
                    v-model="tel"
                    v-cleave="{
                      phone: true,
                      phoneRegionCode: 'JP',
                      delimiter: ' ',
                      onValueChanged: telChanged,
                    }"
                  />
                </div>
              </li>
            </ul>
          </div>
          <!-- 連絡先（通知）メールアドレス -->
          <div class="mail">
            <h3>連絡先（通知）メールアドレス</h3>
            <ul>
              <li>
                <div>
                  <input
                    class="t_c"
                    type="email"
                    :value="email"
                    name="wtn_email"
                    disabled="disabled"
                  />
                </div>
              </li>
            </ul>
          </div>
          <!-- 個人情報の取扱・利用規約について -->
          <div class="privacy">
            <h3>個人情報の取扱・利用規約について</h3>
            <p class="mb05 t_l">
              個人情報保護方針・利用規約にご同意いただく必要がございます。
            </p>
            <p class="mb2 t_l">
              内容をご確認の上、「同意する」にチェックをしていただいてから「お申込み内容の確認」ボタンをクリックして、お進みください。
            </p>
            <ul>
              <li>
                <div class="t_c">
                  <a
                    id="btn_privacyinfo"
                    href="https://tsuitamon.jp/privacy/"
                    target="_blank"
                    @click="onClickAgree1Link"
                    >個人情報保護方針を確認する</a
                  >
                  <p class="att x_sml">
                    ご確認後、「同意する」ボタンが押せるようになります。
                  </p>
                </div>
                <div>
                  <div class="frame" v-bind:class="{ disabled: !agree1Enable }">
                    <input
                      type="radio"
                      name="privacyinfo"
                      id="agree"
                      value="1"
                      v-model="agree1"
                      v-bind:disabled="!agree1Enable"
                    /><label class="lbl" for="agree">同意する</label>
                  </div>
                </div>
                <div>
                  <div class="frame">
                    <input
                      type="radio"
                      name="privacyinfo"
                      id="deny"
                      value="0"
                      v-model="agree1"
                    /><label class="lbl" for="deny">同意しない</label>
                  </div>
                </div>
              </li>
              <li>
                <div class="t_c">
                  <a
                    id="btn_agreement"
                    href="https://tsuitamon.jp/agreement/"
                    target="_blank"
                    @click="onClickAgree2Link"
                    >利用規約を確認する</a
                  >
                  <p class="att x_sml">
                    ご確認後、「同意する」ボタンが押せるようになります。
                  </p>
                </div>
                <div>
                  <div class="frame" v-bind:class="{ disabled: !agree2Enable }">
                    <input
                      type="radio"
                      name="agreement"
                      id="a_agree"
                      value="1"
                      v-model="agree2"
                      v-bind:disabled="!agree2Enable"
                    /><label class="lbl" for="a_agree">同意する</label>
                  </div>
                </div>
                <div>
                  <div class="frame">
                    <input
                      type="radio"
                      name="agreement"
                      id="a_deny"
                      value="0"
                      v-model="agree2"
                    /><label class="lbl" for="a_deny">同意しない</label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <p class="has_error">
          入力エラーがあります。お手数ですが、該当箇所を入力しなおしてください。
        </p>
        <div class="btn">
          <button type="submit" :disabled="!submitEnable">
            確認して申し込む
          </button>
          <button type="button" class="reset" @click="onClickResetBtn">
            リセット</button
          ><br class="sp" />
        </div>
      </form>
    </main>

    <app-footer />

    <scroll-to-top />
    <loading-anim
      v-bind:show="isLoading"
      :loaderColor="AppConst.LOADING.COLOR"
      :boxColor="AppConst.LOADING.BOXCOLOR"
    />
    <select-adr
      ref="selAdr"
      v-if="showSelAdr"
      :zip="zip"
      :list="zipSrchList"
      @select="onAdrSelected"
      @close="onCloseSelAdr"
    />
  </div>
</template>

<script>
import Vue from "vue";
import IcheckMixin from "@mixins/icheck-mixin";
import ValidationMixin from "@mixins/validation-mixin";
import CmnSubMixin from "@mixins/cmnsub-mixin";
import HandleAjaxErrorMixin from "@mixins/handle-ajax-error-mixin";
import CleaveMixin from "@mixins/cleave-mixin";
import AppHeader from "@components/AppHeader";
import HeaderStep from "@components/HeaderStep";
import LoadingAnim from "@components/LoadingAnim";
import AppFooter from "@components/AppFooter";
import ScrollToTop from "@components/ScrollToTop";
import SelectAdr from "@components/SelectAdr";
import axios from "axios";
import AppConst from "@utils/app-const";
import $ from "jquery";

export default {
  name: "Index",
  mixins: [
    IcheckMixin,
    ValidationMixin,
    CmnSubMixin,
    HandleAjaxErrorMixin,
    CleaveMixin,
  ],
  components: {
    AppHeader,
    HeaderStep,
    LoadingAnim,
    AppFooter,
    ScrollToTop,
    SelectAdr,
  },
  data() {
    return {
      validator: null,
      schoolId: null,
      schoolNm: "",
      email: "",
      tauInfo: null,
      parentSei: "", // 保護者姓
      parentMei: "", // 保護者名
      parentSeiKana: "", // 保護者姓ふりがな
      parentMeiKana: "", // 保護者名ふりがな
      studentSei: "", // 子ども姓
      studentMei: "", // 子ども名
      studentSeiKana: "", // 子ども姓ふりがな
      studentMeiKana: "", // 子ども名ふりがな
      gradeId: "", // 学年
      gradeList: [], // 学年一覧
      classId: "", // 学級
      allClassList: [], // 学級一覧（全学年分）
      classList: [], // 学級一覧（現在選択されている学年分）
      zip: "", // 郵便番号
      prefCd: "", // 都道府県CD
      prefNm: "", // 都道府県名
      addr1: "", // 市区町村
      addr2: "", // 丁目・番地・マンション名等
      telM: "", // 緊急連絡先（携帯電話番号）
      tel: "", // 固定電話番号
      agree1: "", // 個人情報同意
      agree2: "", // 利用規約同意
      isLoading: false,
      schoolList: [], // 学校選択肢一覧
      hasInpError: false, // 入力エラーがあるか
      agree1Enable: false, // 個人情報同意ラジオ活性
      agree2Enable: false, // 滋養規約同意ラジオ活性
      zipSrchList: [], // 郵便番号検索結果
      showSelAdr: false, // 住所選択ダイアログを表示するか
      ignoreNextGradeChange: false,
    };
  },
  computed: {
    /**
     * 申込みボタン活性
     */
    submitEnable: function () {
      // 個人情報、利用規約が2つとも「同意する」なら押せる
      return (
        this.agree1 == AppConst.AGREE.YES && this.agree2 == AppConst.AGREE.YES
      );
    },
  },
  created() {},
  mounted() {
    var t = this;
    window.addEventListener("pageshow", function (evt) {
      if (evt.persisted) {
        // ヒストリバックを使えなくする
        window.history.pushState(null, null, window.location.href);
      }
    });
    // ヒストリバックを使えなくする
    window.history.pushState(null, null, window.location.href);
    window.addEventListener("popstate", function () {
      window.history.go(1);
    });

    /* 同意ボタン 非活性 */
    $("input#agree").prop("disabled", true);
    $("input#a_agree").prop("disabled", true);
    // 同意・不同意 ボタン全体が押せるように
    $(".frame").on("click", function () {
      // console.log("frame clicked");
      if (!$(this).hasClass("disabled")) {
        // console.log("frame enable");
        var radio = $(this).find("input[type='radio']");
        switch (radio.attr("name")) {
          case "privacyinfo": {
            t.agree1 = radio.val();
            Vue.nextTick(() => {
              $("input[name='privacyinfo']").iCheck("update");
            });
            break;
          }
          case "agreement": {
            t.agree2 = radio.val();
            Vue.nextTick(() => {
              $("input[name='agreement']").iCheck("update");
            });
            break;
          }
        }
      }
    });
    this.frameHOver(); // マウスオーバーも同調

    // iCheck
    this.loadICheck().then(() => {
      $("input[type='radio']").iCheck({
        radioClass: "iradio_minimal-grey",
      });
      $("input[type='radio']").on("ifChecked", function (evt) {
        // bindしている値に反映させる
        var elem = $(evt.currentTarget);
        switch (elem.attr("name")) {
          case "privacyinfo": {
            t.agree1 = elem.val();
            break;
          }
          case "agreement": {
            t.agree2 = elem.val();
            break;
          }
        }
      });
    });

    // 入力チェック初期化
    this.initValidation();
    // 入力内容取得（CSRFトークン取得はこの中で行う）
    this.loadFormData();
    // 各項目入力更新後のエラー表示更新
    $("input").on("blur", function (evt) {
      t.updateInputError(evt);
    });
    $("select").on("change", function (evt) {
      t.updateInputError(evt);
    });
  },
  methods: {
    /**
     * 郵便番号入力内容変更
     * 7桁入力されたら住所検索を行う
     */
    onChangeZip: function () {
      let t = this;
      // 郵便番号が7桁の数字だったら郵便番号検索実行
      if (this.zip.match(/^\d{7}$/)) {
        t.addrFromZip();
      } else {
        this.prefCd = "";
        this.prefNm = "";
        this.addr1 = "";
      }
    },
    /**
     * 郵便番号から住所自動入力
     */
    addrFromZip: function () {
      if (this.zip.match(/^\d{7}$/)) {
        try {
          this.isLoading = true;
          let url = AppConst.API.EXTURL.ZIP_SEARCH + this.zip;

          axios
            .get(url, { withCredentials: false })
            .then((response) => {
              this.isLoading = false;
              var res = response.data;
              switch (res.status) {
                case 200: {
                  // 正常
                  this.zipSrchList = [];
                  for (var k in res.results) {
                    var one = res.results[k];
                    var pref_cd = ("0" + one.prefcode).substr(-2);
                    this.zipSrchList.push({
                      id: k + 1,
                      pref_cd: pref_cd,
                      pref_name: one.address1,
                      city_name: one.address2,
                      town_name: one.address3,
                    });
                  }
                  var cnt = this.zipSrchList.length;
                  switch (cnt) {
                    case 0: {
                      // 該当なし
                      this.prefCd = "";
                      this.prefNm = "";
                      this.addr1 = "";
                      this.alert(
                        "該当する住所が見つかりません。<br/>郵便番号を確認してください。",
                        "確認",
                        "閉じる"
                      );
                      break;
                    }
                    case 1: {
                      // 確定
                      this.prefCd = this.zipSrchList[0].pref_cd;
                      this.prefNm = this.zipSrchList[0].pref_name;
                      this.addr1 = this.zipSrchList[0].city_name;
                      this.addr2 = this.zipSrchList[0].town_name;
                      Vue.nextTick(() => {
                        $(this.$refs.pref).valid();
                        $(this.$refs.addr1).valid();
                        $(this.$refs.addr2).valid();
                        $(this.$refs.addr2).focus();
                      });
                      break;
                    }
                    default: {
                      // 複数ある場合は選択させる
                      this.showSelAdr = true;
                      break;
                    }
                  }
                  break;
                }
                default: {
                  // エラー（400 or 500)
                  this.alert(
                    "住所を取得できませんでした。<br/>電波状態の良いところで<br class='sp'>再度お試しください。",
                    "確認",
                    "閉じる"
                  );
                  break;
                }
              }
            })
            .catch(() => {
              this.isLoading = false;
              this.alert(
                "住所を取得できませんでした。<br/>電波状態の良いところで<br class='sp'>再度お試しください。",
                "確認",
                "閉じる"
              );
            });
        } catch /*( e )*/ {
          // console.log(e);
          this.isLoading = false;
        }
      }
    },
    onAdrSelected: function (adr) {
      // console.log(adr);
      this.prefCd = adr.pref_cd;
      this.prefNm = adr.pref_name;
      this.addr1 = adr.city_name;
      this.addr2 = adr.town_name;
      this.showSelAdr = false;
      Vue.nextTick(() => {
        $(this.$refs.pref).valid();
        $(this.$refs.addr1).valid();
        $(this.$refs.addr2).valid();
        $(this.$refs.addr2).focus();
      });
    },
    onCloseSelAdr: function () {
      this.showSelAdr = false;
    },
    /**
     * 郵便番号を調べるボタン
     * 郵便局サイトへの遷移確認メッセージ表示
     */
    onClickZipBtn: function () {
      this.confirm({
        title: "郵便番号を調べる",
        message:
          "<fa-icon :icon=\"['fa', 'exclamation-circle']\"></fa-icon>新規タブで郵便局のサイトが開きます。",
        buttons: {
          キャンセル: {
            class: "red",
            action: function () {
              return false;
            },
          },
          OK: {
            color: "#000",
            action: function () {
              window.open("https://www.post.japanpost.jp/zipcode/", "_blank");
            },
          },
        },
      });
    },
    /**
     * 入力チェック初期化
     */
    initValidation: function () {
      var t = this;
      this.loadValidation().then(() => {
        /* フォーム入力チェック */
        t.validator = $(t.$refs.fInp).validate({
          rules: {
            "family-name": {
              required: true,
              maxlength: 30,
            },
            "given-name": {
              required: true,
              maxlength: 30,
            },
            "family-name_kana": {
              required: true,
              hiragana: true,
              maxlength: 30,
            },
            "given-name_kana": {
              required: true,
              hiragana: true,
              maxlength: 30,
            },
            "child_family-name": {
              required: true,
              maxlength: 30,
            },
            "child_given-name": {
              required: true,
              maxlength: 30,
            },
            "child_family-name_kana": {
              required: true,
              hiragana: true,
              maxlength: 30,
            },
            "child_given-name_kana": {
              required: true,
              hiragana: true,
              maxlength: 30,
            },
            grade: {
              required: true,
            },
            class: {
              required: true,
            },
            "postal-code": {
              required: true,
              number: true,
              fixedlength: 7,
            },
            "address-level1": {
              required: true,
              maxlength: 4,
            },
            "address-level2": {
              required: true,
              maxlength: 50,
            },
            "address-level3": {
              required: true,
              maxlength: 100,
            },
            tel: {
              required: true,
              telsp: true,
              maxlength: 13,
            },
            tel2: {
              telsp: true,
              maxlength: 12,
            },
          },
          messages: {
            email: {
              required: "※必須入力項目です。",
              email: "※メールアドレスは xxx@xxxx.xxxxx 形式で入力してください",
            },
            "family-name": {
              required: "※必須入力項目です。",
            },
            "given-name": {
              required: "※必須入力項目です。",
            },
            "family-name_kana": {
              required: "※必須入力項目です。",
            },
            "given-name_kana": {
              required: "※必須入力項目です。",
            },
            "child_family-name": {
              required: "※必須入力項目です。",
            },
            "child_given-name": {
              required: "※必須入力項目です。",
            },
            "child_family-name_kana": {
              required: "※必須入力項目です。",
            },
            "child_given-name_kana": {
              required: "※必須入力項目です。",
            },
            grade: {
              required: "※必須入力項目です。",
            },
            class: {
              required: "※必須入力項目です。",
            },
            "postal-code": {
              required: "※必須入力項目です。",
              minlength: "※7桁で入力してください。",
              maxlength: "※7桁で入力してください。",
              number: "※半角数字で入力してください。",
            },
            "address-level1": {
              required: "※必須入力項目です。",
            },
            "address-level2": {
              required: "※必須入力項目です。",
            },
            "address-level3": {
              required: "※必須入力項目です。",
            },
            tel: {
              required: "※必須入力項目です。",
              number: "※半角数字で入力してください。",
            },
            tel2: {
              number: "※半角数字で入力してください。",
            },
          },
          errorPlacement: function (error, element) {
            if (element.attr("name") == "postal-code") {
              error.insertAfter("#postal-code_error");
            } else {
              error.insertAfter(element);
            }
          },
          focusInvalid: false,
          submitHandler: t.validHandler,
          invalidHandler: t.invalidHandler,
        });
      });
    },
    /**
     * 入力内容取得
     */
    loadFormData: function () {
      let t = this;
      // 申込みURLトークン有効チェック・入力内容取得（確認画面から戻った場合入力内容も取得）
      this.isLoading = true;
      let data = {
        token: t.$route.params.token,
      };
      axios
        .get(process.env.VUE_APP_API_BASE + AppConst.API.URL.CSRF)
        .then((/*response*/) => {
          axios
            .post(process.env.VUE_APP_API_BASE + AppConst.API.URL.GETINP, data)
            .then((response) => {
              t.isLoading = false;
              let res = response.data;
              if (res.res_cd == AppConst.RET_CD.OK) {
                // トークン有効
                // 学年選択肢、学級選択肢を保持、入力内容を復元
                t.gradeList = res.data.grade_list;
                t.allClassList = res.data.class_list;
                if (res.data.validated == AppConst.FLAG.ON) {
                  // 入力チェック済み（＝確認画面からの戻り）の場合は同意を活性
                  t.agree1Enable = true;
                  $("#agree").iCheck("enable");
                  t.agree2Enable = true;
                  $("#a_agree").iCheck("enable");
                }
                t.restoreValues(res.data.inp);
                // console.log(t.gradeList, t.classList, res.data.inp);
              } else {
                // トークン無効
                switch (res.res_errcd) {
                  case AppConst.API_ERRCD.TAU_EXPIRED: {
                    // 期限切れエラー
                    this.$router.push({ name: AppConst.ROUTENM.EXPIRED });
                    return;
                  }
                  case AppConst.API_ERRCD.TAU_APPLIED: {
                    // 申込済み
                    this.$router.push({
                      name: AppConst.ROUTENM.ERROR,
                      params: { errCd: AppConst.ERRSCR_ERRCD.TAU_COMPLETED },
                    });
                    return;
                  }
                }
              }
            })
            .catch((reason) => {
              t.isLoading = false;
              // エラー
              if (!this.handleAjaxError(reason.response, false, null)) {
                this.showRetry();
              }
            });
        })
        .catch((reason) => {
          t.isLoading = false;
          // エラー
          if (!this.handleAjaxError(reason.response, false, null)) {
            this.showRetry();
          }
        });
    },
    /**
     * 入力値復元
     */
    restoreValues: function (inp) {
      this.ignoreNextGradeChange = true;
      this.schoolId = inp.school_id ? inp.school_id : null;
      this.schoolNm = inp.school_nm ? inp.school_nm : "";
      this.email = inp.email ? inp.email : "";
      this.parentSei = inp.parent_sei ? inp.parent_sei : "";
      this.parentMei = inp.parent_mei ? inp.parent_mei : "";
      this.parentSeiKana = inp.parent_sei_kana ? inp.parent_sei_kana : "";
      this.parentMeiKana = inp.parent_mei_kana ? inp.parent_mei_kana : "";
      this.studentSei = inp.student_sei ? inp.student_sei : "";
      this.studentMei = inp.student_mei ? inp.student_mei : "";
      this.studentSeiKana = inp.student_sei_kana ? inp.student_sei_kana : "";
      this.studentMeiKana = inp.student_mei_kana ? inp.student_mei_kana : "";
      this.gradeId = inp.grade_id ? inp.grade_id : "";
      this.classId = inp.class_id ? inp.class_id : "";
      this.zip = inp.zip ? inp.zip.replace("-", "") : "";
      this.prefCd = inp.pref_cd ? inp.pref_cd : "";
      this.prefNm = inp.pref_name ? inp.pref_name : "";
      this.addr1 = inp.addr1 ? inp.addr1 : "";
      this.addr2 = inp.addr2 ? inp.addr2 : "";
      this.telM = inp.mobile_tel ? inp.mobile_tel.replace("-", " ") : "";
      this.tel = inp.fixed_tel ? inp.fixed_tel.replace("-", " ") : "";
      this.agree1 = inp.agree1 ? inp.agree1 : "";
      this.agree2 = inp.agree2 ? inp.agree2 : "";
      // CleaveJSを使っている項目はCleaveJSにもセット
      this.$refs.mobileTel.cleave.setRawValue(this.telM);
      this.$refs.fixedTel.cleave.setRawValue(this.tel);
      Vue.nextTick(() => {
        // 同意iCheck表示更新
        $("input[type='radio']").iCheck("update");
      });
    },
    /**
     * リセットボタン
     */
    onClickResetBtn: function () {
      // console.log("agree1", this.agree1, "agree2", this.agree2);
      const clvs = ["#mobile-tel", "#fixed-tel"];
      clvs.forEach((selector) => {
        const elem = $(selector).get(0);
        if (elem && elem.cleave) {
          elem.cleave.setRawValue("");
        }
      });
      this.parentSei = "";
      this.parentMei = "";
      this.parentSeiKana = "";
      this.parentMeiKana = "";
      this.studentSei = "";
      this.studentMei = "";
      this.studentSeiKana = "";
      this.studentMeiKana = "";
      this.gradeId = "";
      this.classId = "";
      this.zip = "";
      this.prefCd = "";
      this.prefNm = "";
      this.addr1 = "";
      this.addr2 = "";
      this.telM = "";
      this.tel = "";
      this.agree1 = "";
      this.agree2 = "";
      Vue.nextTick(() => {
        // console.log("reset", this.$refs.fInp);
        // $(this.$refs.fInp).validate().resetForm();
        this.validator.resetForm();
        $("input[type='radio']").iCheck("uncheck");
        $("input[type='radio']").iCheck("update");
        $(".has_error").hide();
      });
      // this.makeValidator();
    },
    /**
     * 同意説明リンククリック
     */
    onClickAgree1Link: function () {
      this.agree1Enable = true;
      $("#agree").iCheck("enable");
    },
    onClickAgree2Link: function () {
      this.agree2Enable = true;
      $("#a_agree").iCheck("enable");
    },
    /**
     * 同意ラジオ枠のマウスオーバー効果
     */
    frameHOver: function () {
      $(".frame").on({
        mouseenter: function () {
          if (!$(this).hasClass("disabled")) {
            $(this).children(".iradio_minimal-grey").addClass("hover");
          }
        },
        mouseleave: function () {
          if (!$(this).hasClass("disabled")) {
            $(this).children(".iradio_minimal-grey").removeClass("hover");
          }
        },
      });
    },
    /**
     * 電話番号欄入力値変更
     * iPhoneの「連絡先を自動入力」機能で入力したときに、cleave.jsが値をフォーマットする前にvalidateがエラーを表示することがあるので、
     * 値変更後にvalid()を呼んでエラー表示の更新を行う
     */
    telChanged: function (e) {
      // console.log(e);
      if (e.target.rawValue.length > 0) {
        Vue.nextTick(() => {
          var s = "input[name='" + e.target.name + "']";
          $(s).valid();
        });
      }
    },
    /**
     * バリデーションOK
     */
    validHandler: function (/* form */) {
      // console.log("validHandler");
      $(".has_error").hide();
      var token = this.$route.params.token;

      var data = {
        token: token,
        parent_sei: this.parentSei,
        parent_mei: this.parentMei,
        parent_sei_kana: this.parentSeiKana,
        parent_mei_kana: this.parentMeiKana,
        student_sei: this.studentSei,
        student_mei: this.studentMei,
        student_sei_kana: this.studentSeiKana,
        student_mei_kana: this.studentMeiKana,
        grade_id: this.gradeId,
        class_id: this.classId,
        zip: this.zip,
        pref_cd: this.prefCd,
        addr1: this.addr1,
        addr2: this.addr2,
        mobile_tel: this.telM,
        fixed_tel: this.tel,
        agree1: this.agree1,
        agree2: this.agree2,
      };
      this.isLoading = true;
      axios
        .get(process.env.VUE_APP_API_BASE + AppConst.API.URL.CSRF)
        .then((/*response*/) => {
          axios
            .post(
              process.env.VUE_APP_API_BASE + AppConst.API.URL.VALIDATE,
              data
            )
            .then((response) => {
              this.isLoading = false;
              let res = response.data;
              if (res.res_cd == AppConst.RET_CD.OK) {
                // 成功
                // 申込み内容確認画面に遷移
                this.$router.push({
                  name: AppConst.ROUTENM.CONFIRM,
                  params: {
                    token: token,
                  },
                });
              } else {
                this.alert(res.errmsg, "情報", "閉じる");
              }
            })
            .catch((reason) => {
              this.isLoading = false;
              // エラー
              if (!this.handleAjaxError(reason.response, false, null)) {
                this.showRetryClose();
              }
            });
        })
        .catch((reason) => {
          this.isLoading = false;
          // エラー
          if (!this.handleAjaxError(reason.response, false, null)) {
            this.showRetryClose();
          }
        });
    },
    /**
     * バリデーションNG
     */
    invalidHandler: function () {
      // console.log("invalidHandler");
      $(".has_error").show();
    },
    /**
     * 入力項目1個変更時、その項目のエラー有無表示を更新し、全体エラー有無表示状態を更新する
     * 全体エラーは、送信ボタンを押したときの入力チェックNGの時に表示し、
     * その後、エラー項目がなくなったら消す。
     */
    updateInputError: function (e) {
      // 対象項目1個のエラーチェック
      $(e.currentTarget).valid();
      Vue.nextTick(function () {
        // console.log($("input.error").length, "-", $("select.error").length);
        if ($("input.error").length === 0 && $("select.error").length === 0) {
          $(".has_error").hide();
        }
      });
    },
  },
  watch: {
    /**
     * 学年選択変更
     */
    gradeId: function (newVal /*, oldVal */) {
      // console.log("gradeChanged", newVal);
      if (!newVal) {
        this.classList = [];
      } else {
        if (this.allClassList[newVal]) {
          this.classList = this.allClassList[newVal];
        } else {
          this.classList = [];
        }
      }
      if (!this.ignoreNextGradeChange) {
        this.classId = "";
      }
      this.ignoreNextGradeChange = false;
    },
  },
  beforeDestroy: function () {
    this.$refs.mobileTel.cleave.destroy();
    this.$refs.fixedTel.cleave.destroy();
  },
};
</script>
